import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router';
import { router } from './router';
import { AuthProvider } from '~/contexts/AuthContext';
import { ThemeProvider } from 'next-themes';
import { QueryProvider } from '~/providers/query-provider';
import { StoreProvider } from '~/stores/store-provider';
import { HydrationProvider } from '~/components/app-wide-loader/hydration-provider';
import './app/globals.css';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ThemeProvider
      attribute="data-theme"
      defaultTheme="dark"
      themes={["light", "dark"]}
      enableSystem={false}
    >
      <QueryProvider>
        <StoreProvider>
          <HydrationProvider>
            <AuthProvider>
              <RouterProvider router={router} />
            </AuthProvider>
          </HydrationProvider>
        </StoreProvider>
      </QueryProvider>
    </ThemeProvider>
  </StrictMode>
);
